import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import Swal from "sweetalert2";
import { selectHasPermission } from "../store/slices/authSlice";
import InjectionList from "../pages/Injection/InjectionList";
import { fetchInjections, deleteInjection, clearError } from "../store/slices/injectionsSlice"; // adjust path

const Injections = () => {
    const navigate = useNavigate();

    // ✅ Mock permissions
    const canManageInjections = useSelector((state) =>
        selectHasPermission(state, "injections-manage")
    );
    const canCreateInjections = useSelector((state) =>
        selectHasPermission(state, "injections-create")
    );
    const canEditInjections = useSelector((state) =>
        selectHasPermission(state, "injections-edit")
    );
    const canDeleteInjections = useSelector((state) =>
        selectHasPermission(state, "injections-delete")
    );

    // ✅ Mock Data
    const dispatch = useDispatch();
    const injections = useSelector((state) => state.injections.injections);
    const currentInjection = useSelector((state) => state.injections.currentInjection);
    const isLoading = useSelector((state) => state.injections.isLoading);
    const error = useSelector((state) => state.injections.error);

    // ✅ Simulate fetch
    useEffect(() => {
        dispatch(fetchInjections()); // fetch all injections
    }, [dispatch]);


    // ✅ Action Handlers
    const handleAddInjection = () => navigate("/injection/add");
    const handleEditInjection = (id) => navigate(`/injection/edit/${id}`);
    const handleDeleteInjection = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You want to delete this injection record?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
        });

        if (result.isConfirmed) {
            try {
                await dispatch(deleteInjection(id)).unwrap(); // unwrap handles success/errors
                Swal.fire("Deleted!", "Injection record has been deleted.", "success");
            } catch (err) {
                Swal.fire("Error!", err || "Failed to delete injection record.", "error");
            }
        }
    };

    // ✅ Handle permission restriction
    if (!canManageInjections) {
        return (
            <Navigate
                to="/dashboard"
                state={{ error: "You do not have permission to manage injections." }}
                replace
            />
        );
    }

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                {/* ===== Injection Table ===== */}
                <div className="card">
                    <div className="card-body">
                        {isLoading ? (
                            <div className="d-flex justify-content-center py-5">
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <InjectionList
                                injections={injections}
                                onEditInjection={canEditInjections ? handleEditInjection : null}
                                onDeleteInjection={
                                    canDeleteInjections ? handleDeleteInjection : null
                                }
                                onAddInjection={canCreateInjections ? handleAddInjection : null}
                            />
                        )}
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default Injections;
